module.exports = __webpack_public_path__ + "img/default-avatar.cd226107.svg";